var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestOverviewGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65715 1.97144H3.64286C2.71977 1.97144 1.97144 2.71977 1.97144 3.64286V8.65715C1.97144 9.58025 2.71977 10.3286 3.64286 10.3286H8.65715C9.58025 10.3286 10.3286 9.58025 10.3286 8.65715V3.64286C10.3286 2.71977 9.58025 1.97144 8.65715 1.97144Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3571 13.6714H15.3428C14.4197 13.6714 13.6714 14.4198 13.6714 15.3429V20.3571C13.6714 21.2803 14.4197 22.0286 15.3428 22.0286H20.3571C21.2802 22.0286 22.0285 21.2803 22.0285 20.3571V15.3429C22.0285 14.4198 21.2802 13.6714 20.3571 13.6714Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.85 1.97144C17.85 1.97144 22.0285 1.97144 22.0285 6.15001C22.0285 6.15001 22.0285 10.3286 17.85 10.3286C17.85 10.3286 13.6714 10.3286 13.6714 6.15001C13.6714 6.15001 13.6714 1.97144 17.85 1.97144Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15001 13.6714C6.15001 13.6714 10.3286 13.6714 10.3286 17.85C10.3286 17.85 10.3286 22.0286 6.15001 22.0286C6.15001 22.0286 1.97144 22.0286 1.97144 17.85C1.97144 17.85 1.97144 13.6714 6.15001 13.6714Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestOverviewGrey);
export default __webpack_public_path__ + "static/media/invest_overview_grey.4861bda0ff7386e05134b178429122de.svg";
export { ForwardRef as ReactComponent };